// Global alert and confirm utilities
// These replace window.alert and window.confirm with toast notifications and confirmation dialogs

type ToastFunctions = {
    alert: (message: string, title?: string) => void;
    confirm: (message: string, options?: { title?: string; confirmText?: string; cancelText?: string }) => Promise<boolean>;
};

let toastFunctions: ToastFunctions | null = null;

export const setToastFunctions = (functions: ToastFunctions) => {
    toastFunctions = functions;
};

export const alert = (message: string, title?: string): void => {
    if (toastFunctions) {
        toastFunctions.alert(message, title);
    } else {
        // Fallback to browser alert if toast is not initialized
        window.alert(title ? `${title}\n\n${message}` : message);
    }
};

export const confirm = (
    message: string,
    options?: { title?: string; confirmText?: string; cancelText?: string }
): Promise<boolean> => {
    if (toastFunctions) {
        return toastFunctions.confirm(message, options);
    } else {
        // Fallback to browser confirm if toast is not initialized
        return Promise.resolve(window.confirm(message));
    }
};

